module.exports = __webpack_public_path__ + "img/DrySystem_Overview-DS_1.a6acf898.jpg";